import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import Layout from './components/Layout';
import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import SuppliersList from "./pages/Suppliers/SuppliersList";
import ShipmentsList from "./pages/Shipments/ShipmentsList";
import ShipmentDetail from "./pages/Shipments/ShipmentDetail";
import ShipmentForm from "./pages/Shipments/ShipmentForm";
import Form2 from "./pages/Shipments/Form2";
import Form3 from "./pages/Shipments/Form3";
import ShipmentFormSelection from "./pages/Shipments/ShipmentFormSelection";
import UploadShipments from "./pages/Shipments/UploadShipments";
import ProtectedRoute from "./components/ProtectedRoute";
import Pickups from "./pages/Pickups/Pickups";
import Settings from "./pages/Settings./Settings";
import UploadMaterialComposites from "./pages/Material Composites/UploadMaterialComposites";
import MaterialCompositesForm from "./pages/Material Composites/MaterialCompositesForm";
import MaterialCompositesFormSelection from "./pages/Material Composites/MaterialCompositesFormSelection";
import MaterialCompositesDetail from "./pages/Material Composites/MaterialCompositesDetail";

function App() {
  const [shipments, setShipments] = useState([]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {/* Public Route: Login */}
        <Route path="/" element={<Login />} />

        {/* Protected Routes with Layout */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard shipments={shipments} setShipments={setShipments} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/suppliers"
          element={
            <ProtectedRoute>
              <Layout>
                <SuppliersList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/shipments"
          element={
            <ProtectedRoute>
              <Layout>
                <ShipmentsList shipments={shipments} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/shipments/:shipmentId"
          element={
            <ProtectedRoute>
              <Layout>
                <ShipmentDetail shipments={shipments} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/shipments/new"
          element={
            <ProtectedRoute>
              <Layout>
                <ShipmentFormSelection />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/shipments/new/form1"
          element={
            <ProtectedRoute>
              <Layout>
                <ShipmentForm />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/shipments/new/form2"
          element={
            <ProtectedRoute>
              <Layout>
                <Form2 />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/shipments/new/form3"
          element={
            <ProtectedRoute>
              <Layout>
                <Form3 />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/shipments/upload"
          element={
            <ProtectedRoute>
              <Layout>
                <UploadShipments />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/material-composites/:compositeId"
          element={
            <ProtectedRoute>
              <Layout>
                <MaterialCompositesDetail shipments={shipments} />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/material-composites/new"
          element={
            <ProtectedRoute>
              <Layout>
                <MaterialCompositesFormSelection />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/material-composites/new/form1"
          element={
            <ProtectedRoute>
              <Layout>
                <MaterialCompositesForm />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/material-composites/new/form2"
          element={
            <ProtectedRoute>
              <Layout>
                <Form2 />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/material-composites/new/form3"
          element={
            <ProtectedRoute>
              <Layout>
                <Form3 />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/material-composites/upload"
          element={
            <ProtectedRoute>
              <Layout>
                <UploadMaterialComposites />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/pickups"
          element={
            <ProtectedRoute>
              <Layout>
                <Pickups />
              </Layout>
            </ProtectedRoute>
          }
        />
       
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Layout>
                <Settings />
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
